import { BrowserModule } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { NgModule, LOCALE_ID, Injector, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { initFirebaseBackend } from "./authUtils";
import { environment } from "../environments/environment";
// import {
//     LayoutsModule
// } from './layouts/layouts.module';
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";

import { NgxImageZoomModule } from 'ngx-image-zoom';
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import {
    HttpClient,
    HttpClientModule,
    HTTP_INTERCEPTORS,
} from "@angular/common/http";
import { AsyncPipe, registerLocaleData } from "@angular/common";
import { NgProgressModule } from "ngx-progressbar";
import { NgProgressHttpModule } from "ngx-progressbar/http";
import { ServiceWorkerModule } from "@angular/service-worker";
import { AngularFireMessagingModule } from "@angular/fire/messaging";
import { AngularFireModule } from "@angular/fire";
import { MessagingService } from "./core/services/messaging.service";
import { TawktoService } from "./core/services/tawkto.service";
import { NgbDateParserFormatter } from "@ng-bootstrap/ng-bootstrap";
import { NgbDateCustomParserFormatter } from "./core/date-formatter";
import { NgSelectModule } from "@ng-select/ng-select";
import { ScrollingModule } from '@angular/cdk/scrolling';

import { APP_INITIALIZER } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LOCATION_INITIALIZED } from "@angular/common";

import localeId from "@angular/common/locales/id";
import { HttpConfigInterceptor } from "./interceptor/httpconfig.interceptor";
import { NgxOrgChartModule } from 'ngx-org-chart';

import { NgxGoogleAnalyticsModule, NgxGoogleAnalyticsRouterModule } from 'ngx-google-analytics';

import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { DatepickerModule } from 'ngx-bootstrap/datepicker';
import { TimepickerModule } from 'ngx-bootstrap/timepicker';
import { NgxFileDropModule } from 'ngx-file-drop';

registerLocaleData(localeId);
initFirebaseBackend(environment.firebaseConfig);

export function playerFactory() {
  return import('lottie-web');
}

@NgModule({
    declarations: [AppComponent],
    imports: [
        ScrollingModule,
        BrowserModule,
        BrowserAnimationsModule,
        HttpClientModule,
        AppRoutingModule,
        NgProgressModule,
        NgProgressHttpModule,
        ServiceWorkerModule.register("ngsw-worker.js", {
            enabled: environment.production,
        }),
        AngularFireMessagingModule,
        AngularFireModule.initializeApp(environment.firebaseConfig),
        HttpClientModule,
        NgSelectModule,
        NgxImageZoomModule,
        NgxOrgChartModule,  
        TranslateModule.forRoot({
            loader: {
                provide: TranslateLoader,
                useFactory: httpTranslateLoader,
                deps: [HttpClient],
            },
        }),
        NgxGoogleAnalyticsModule.forRoot(environment.firebaseConfig.measurementId),
        NgxGoogleAnalyticsRouterModule,
        BsDropdownModule.forRoot(),
        DatepickerModule.forRoot(),
        TimepickerModule.forRoot(),
        NgxFileDropModule
    ],
    // providers: [AsyncPipe],
    providers: [
        TawktoService,
        MessagingService,
        AsyncPipe,
        {
            provide: NgbDateParserFormatter,
            useClass: NgbDateCustomParserFormatter,
        },
        { 
            provide: LOCALE_ID, useValue: "id-ID" 
        },
        {
            provide: HTTP_INTERCEPTORS,
            useClass: HttpConfigInterceptor,
            multi: true,
        },
        {
            provide: APP_INITIALIZER,
            useFactory: appInitializerFactory,
            deps: [TranslateService, Injector],
            multi: true,
        },
    ],
    bootstrap: [AppComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})

export class AppModule {}

// AOT compilation support
export function httpTranslateLoader(http: HttpClient) {
    return new TranslateHttpLoader(http);
}

export function appInitializerFactory(translate: TranslateService, injector: Injector) {
  return () => new Promise<any>((resolve: any) => {
    const locationInitialized = injector.get(LOCATION_INITIALIZED, Promise.resolve(null));
    locationInitialized.then(() => {
      let langToSet = 'IND';
      try {
        const userDetail = JSON.parse(localStorage.getItem('userDetail'));
        if (userDetail && (userDetail.bahasa === 'ENG' || userDetail.bahasa === 'IND')) {
          langToSet = userDetail.bahasa;
        }
      } catch (e) {}
      translate.setDefaultLang(langToSet);
      translate.use(langToSet).subscribe(() => {
      }, err => {
      }, () => {
        resolve(null);
      });
    });
  });
}

// export function appInitializerFactory(translate: TranslateService) {
//      return async () => { 
//         translate.setDefaultLang('ENG');
//         translate.use('ENG');
//         return new Promise(resolve => {
//             translate.onLangChange.subscribe(() => {
//                 resolve();
//             });
//         });
//     };
// }
